import StudentApi from '../helper/StudentApi';
import { gradeString } from '../helper/dataCleanupUtil';
import validateOnChallengeRules from '../helper/challengeRuleValidation';

export const WATCHLIST_UPDATE = 'user/WATCHLIST_UPDATE';
export const READLIST_UPDATE = 'user/READLIST_UPDATE';
export const SEARCH_STATUS = 'user/SEARCH_STATUS';
export const BOOKLIST_UPDATE = 'user/BOOKLIST_UPDATE';
export const PRC_BOOK_ADD = 'user/PRC_BOOK_ADD';
export const PERSONAL_BOOK_ADD = 'user/PERSONAL_BOOK_ADD';
export const PERSONAL_BOOK_REMOVE = 'user/PERSONAL_BOOK_REMOVE';
export const PERSONAL_CHOICE_UPDATE = 'user/PERSONAL_BOOK_UPDATE';
export const TABVALUE_CHANGE = 'TABVALUE_CHANGE';
export const GENRES_UPDATE = 'GENRES_UPDATE';
export const CHALLENGE_LEVEL_UPDATE = 'CHALLENGE_LEVEL_UPDATE';
export const CHALLENGE_RULE_UPDATE = 'CHALLENGE_RULE_UPDATE';
export const LOGON_ENABLED_UPDATE= 'LOGON_ENABLED_UPDATE';

const initialState = {
    userId: null,
    name: 'Linda MaGill',
    school: 'Smith Public School',
    grade: 6,
    tabValue: 0,
    watchList: [],
    readList: [],
    personalBookList: [],
    searchStatus: '',
    challengeLevels: [],
    challengeRules: [],
    bookGenres:[],
    bookList: [],
    logonEnabled: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case WATCHLIST_UPDATE:
            return {
                ...state,
                watchList: [...action.payload],
            }

        case READLIST_UPDATE: return {
            ...state,
            readList: [...action.payload],
        }

        case SEARCH_STATUS: {
            return {
                ...state,
                searchStatus: action.payload
            }
        }

        case TABVALUE_CHANGE: {
            return {
                ...state,
                tabValue: action.payload
            }
        }

        case BOOKLIST_UPDATE: {
            return {
                ...state,
                bookList: action.payload
            }
        }

        case PERSONAL_BOOK_ADD: return {
            ...state,
            personalBookList: [
                ...state.personalBookList,
                action.payload,
            ]
        }

        case PERSONAL_BOOK_REMOVE: {
            const prunedList = state.personalBookList.filter(item => {
                return item !== action.payload
            })
            return {
                ...state,
                personalBookList: prunedList
            }
        }

        case PERSONAL_CHOICE_UPDATE: return {
            ...state,
            personalBookList: action.payload,
        }

        case GENRES_UPDATE: return {
            ...state,
            bookGenres: [...action.payload],
        }

        case CHALLENGE_LEVEL_UPDATE: return {
            ...state,
            challengeLevels: [...action.payload],
        }

        case CHALLENGE_RULE_UPDATE: return {
            ...state,
            challengeRules: [...action.payload],
        }

        case LOGON_ENABLED_UPDATE: return {
            ...state,
            logonEnabled: [...action.payload],
        }

        default:
            return state
    }
}

export const addToWatchList = (book) => {
    return (dispatch) => {
        StudentApi.saveBookToPlan(book)
            .then( ReadingPlan => {
                dispatch(updateWatchList(ReadingPlan.books))
            }).catch(err => console.log(err));
    }
}

export const removeFromWatchList = (book) => {
    return (dispatch) => {
        StudentApi.removeBookFromPlan(book.bookId)
            .then( ReadingPlan => {
                dispatch(updateWatchList(ReadingPlan.books))
            }).catch(err => console.log(err));
    }
}

export const addToReadList = (book) => {
    return (dispatch, getState) => {
        const action = {
            type: PRC_BOOK_ADD,
            payload: book,
        };
        return validateOnChallengeRules(action, getState())
            .then(({shouldTreatAsChoice}) => {
                const isBookInWatchList = getState().user.watchList.find(b => b.bookId === book.bookId);
                const addBook = shouldTreatAsChoice ?
                    StudentApi.addNonPrcBookToLog(book) :
                    StudentApi.addPrcBookToLog(book);

                addBook
                    .then(ReadingList => {
                        dispatch(updatePersonalChoiceList(ReadingList.books))
                        dispatch(updateReadList(ReadingList.books))
                    }).catch(err => console.log(err));
                
                if (isBookInWatchList) {
                    dispatch(removeFromWatchList(book));
                }
            })
            .catch(brokenRule =>
                dispatch({
                    type: `${action.type}_FAILED`,
                    payload: brokenRule
                })
            );
    }
}

export const removeFromReadList = (book) => {
    return (dispatch) => {
        StudentApi.removeBookFromLog(book.bookId)
            .then( ReadingList => {
                dispatch(updateReadList(ReadingList.books))
                dispatch(updatePersonalChoiceList(ReadingList.books))
            }).catch(err => console.log(err));
    }
}

export const changeSearchStatus = (status) => {
    return dispatch => {
        dispatch({
            type: SEARCH_STATUS,
            payload: status
        })
    }
}

export const changeProfileTabValue = (value) => {
    return dispatch => {
        dispatch({
            type: TABVALUE_CHANGE,
            payload: value
        })
    }
}

export const booklistUpdate = (data, status) => {
    return dispatch => {
        dispatch({
            type: BOOKLIST_UPDATE,
            payload: data
        })

        dispatch({
            type: SEARCH_STATUS,
            payload: status
        })
    }
}

export const addPersonalBook = (book) => {
    return (dispatch, getState) => {
        const action = {  //update personal books number in store
            type: PERSONAL_BOOK_ADD,
            payload: book.bookId
        };
        return validateOnChallengeRules(action, getState())
            .then(() =>
                StudentApi.addNonPrcBookToLog(book)
                    .then(ReadingList => {
                        dispatch(updatePersonalChoiceList(ReadingList.books))
                        dispatch(updateReadList(ReadingList.books))
                    }).catch(err => console.log(err))
            )
            .catch(brokenRule =>
                dispatch({
                    type: `${action.type}_FAILED`,
                    payload: brokenRule
                })
            );
    };
}

export const updatePersonalChoiceList = (data) => ({
    type: PERSONAL_CHOICE_UPDATE,
    payload: data.filter(b => b.isOfficial === false || b.isOfficial === 'F').map(b => b.bookId)
});

export const updateReadList = (data) => ({
    type: READLIST_UPDATE,
    payload: data
})

export const updateWatchList = (data) => ({
    type: WATCHLIST_UPDATE,
    payload: data
})


export const bookGenresUpdate = (genres) => ({
    type: GENRES_UPDATE,
    payload: genres.map( g => ({
        label: g,
        value: g
    }))
})

export const challengeLevelUpdate = (levels) => ({
    type: CHALLENGE_LEVEL_UPDATE,
    payload: levels.map( l => ({
        label: gradeString(l),
        value: l
    }))
})

export const challengeRulesUpdate = (rules) => ({
    type: CHALLENGE_RULE_UPDATE,
    payload: rules,
})

export const resetSearch = () => ({
    type: SEARCH_STATUS,
    payload: 'reset',
})

export const logonEnabledUpdate = (logonEnabled) => ({
  type: LOGON_ENABLED_UPDATE,
  payload: logonEnabled,
})


